import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import { MessageBox, Loading } from 'element-ui'
import global from './global'

let obj = {
	'Content-Type': 'application/json'
}

const instance = axios.create({
	baseURL: global.baseURL,
	headers: obj,
	timeout: 60000
})

axios.defaults.withCredentials = true

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
	//设置token
	let token = sessionStorage.getItem('resData')
	config.headers['Authorization'] = token
	// NProgress.start()
	return config
}, function (error) {
	// 1. 判断请求超时
	if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
		console.log('网络请求超时')
		// return service.request(originalRequest);//再重复请求一次
	}
	// 2. 需要重定向到错误页面
	const errorInfo = error.response
	if (errorInfo) {
		//error =errorInfo.data  //页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
		const errorStatus = errorInfo.status // 404 403 500 ...
		router.push({
			path: `/error/${errorStatus}`
		})
	}
	return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
}
);

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
	const res = response.data
	if (res.code === 401 || res.code === 7) {
		handleUnauthorized()
		// 返回一个永远pending的Promise，完全终止请求链，不会触发任何catch
      return new Promise(() => {})
	} else if (response.status == 200) {
		return res
	}
	return response
}, function (error) {
	// HTTP 状态码处理
	if (error.response) {
		switch (error.response.status) {
			case 401:
				handleUnauthorized()
				break
			case 403:
				Message.error('没有权限访问')
				break
			case 500:
				Message.error('服务器内部错误')
				break
			default:
				Message.error('网络错误')
		}
	} else if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
		handleTimeout()
		// 终止超时请求
      return new Promise(() => {})
	} else {
		Message.error('网络连接异常')
	}
	return Promise.reject(error)
});

// 统一处理未授权
function handleUnauthorized() {
	MessageBox({
		type: 'warning',
		iconClass: 'el-icon-warning',
		title: '提示',
		message: '登录超时，请重新登录！',
		showCancelButton: false,
		confirmButtonText: '重新登录',
		beforeClose: (action, instance, done) => {
			if (action === 'confirm') {
				// 清除本地存储的 token 等信息
				localStorage.removeItem('token')
				localStorage.removeItem('userInfo')

				// 跳转到登录页
				router.push({
					path: '/login',
					query: {
						redirect: router.currentRoute.fullPath
					}
				})
			}
			done()
		}
	})
};

// 统一处理超时
function handleTimeout() {
	MessageBox({
		type: 'warning',
		iconClass: 'el-icon-warning',
		title: '网络连接超时,请检查网络',
		message: '请检查网络连接是否良好，并尝试点击重试！',
		closeOnClickModal: false,
		showCancelButton: false,
		confirmButtonText: '请点击重试',
		showClose: false,
		beforeClose: (action, instance, done) => {
			if (action === 'confirm') {
				instance.confirmButtonLoading = true
				instance.confirmButtonText = '连接中...'
				window.location.reload()
				setTimeout(() => {
					done()
					instance.confirmButtonLoading = false
				}, 1500)
			} else done()
		}
	})
};

export default instance
// Vue.prototype.$axios = instance



// WEBPACK FOOTER //
// ./src/axiosUtils.js